import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { Box, IconButton, Skeleton } from '@mui/material'

// Loading placeholder for the desktop DateCarousel. It mirrors the carousel's
// layout (py/px, arrows, 7 date columns with two text lines) so the real carousel
// slots into the exact same space with no layout shift (CLS).
const SKELETON_DATES = 7

const DateCarouselSkeleton = () => {
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'center',
                py: 2,
                backgroundColor: 'background.paper',
                px: 2
            }}
        >
            <IconButton disabled sx={{ color: 'textColors.subheading', mr: 1 }} size="small">
                <ArrowBackIosNewIcon sx={{ fontSize: 16 }} fontSize="inherit" />
            </IconButton>

            <Box
                sx={{
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    maxWidth: 900,
                    p: 0,
                    m: 0,
                    gap: 0.5
                }}
            >
                {Array.from({ length: SKELETON_DATES }).map((_, index) => (
                    <Box
                        key={`date-skeleton-${index}`}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            px: 0.5,
                            flex: 1
                        }}
                    >
                        <Skeleton variant="text" width={64} height={14} sx={{ mb: 0.5 }} />
                        <Skeleton variant="text" width={40} height={14} />
                    </Box>
                ))}
            </Box>

            <IconButton disabled sx={{ color: 'textColors.subheading', ml: 1 }} size="small">
                <ArrowForwardIosIcon sx={{ fontSize: 16 }} fontSize="inherit" />
            </IconButton>
        </Box>
    )
}

export default DateCarouselSkeleton
